import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectTriggerProps, SelectValue } from '@/comps/primitives/select';
import { WithClassName, WithDisabled } from '@/types/component';
import { cn } from '@/utils/shad';
import { NebulyTwColor } from '@/utils/colors';
export type UISelectOption<TValue = string> = {
  value: TValue;
  label: string;
  icon?: React.ReactNode;
};
export type UISelectOptionWithColor<TValue = string> = UISelectOption<TValue> & {
  color: NebulyTwColor;
};
type Props<TValue> = WithDisabled & WithClassName & Pick<SelectTriggerProps, 'caretIcon'> & {
  value: TValue | null;
  options: UISelectOption<TValue>[];
  onChange: (value: TValue) => void;
  placeholder?: string;
  selectedItemIcon?: React.ReactNode;
  onOpen?: () => void;
  onClose?: () => void;
  open?: boolean;
  setOpen?: (open: boolean) => void;
  classNameContent?: string;
  disableScrolling?: boolean;
  renderValue?: (value: TValue | null, config?: {
    icon?: React.ReactNode;
  }) => React.ReactNode;
  required?: boolean;
  fullWidth?: boolean;
  renderContent?: (options: UISelectOption<TValue>[], defaultContent: React.ReactNode) => React.ReactNode;
  ariaLabel?: string;
};
type PropsWithColor<TValue> = WithDisabled & WithClassName & Pick<SelectTriggerProps, 'caretIcon'> & {
  value: TValue | null;
  options: UISelectOptionWithColor<TValue>[];
  onChange: (value: TValue) => void;
  placeholder?: string;
  selectedItemIcon?: React.ReactNode;
  onOpen?: () => void;
  onClose?: () => void;
  open?: boolean;
  setOpen?: (open: boolean) => void;
  classNameContent?: string;
  disableScrolling?: boolean;
  renderValue?: (value: TValue | null, config?: {
    icon?: React.ReactNode;
  }) => React.ReactNode;
  required?: boolean;
  fullWidth?: boolean;
  renderContent?: (options: UISelectOption<TValue>[], defaultContent: React.ReactNode) => React.ReactNode;
  ariaLabel?: string;
};
export function ColoredUISelect(t0) {
  const $ = _c(91);
  const {
    className,
    disabled,
    value,
    options,
    onChange,
    onOpen,
    onClose,
    open,
    setOpen,
    disableScrolling,
    classNameContent,
    renderValue,
    caretIcon,
    required,
    fullWidth: t1,
    renderContent,
    ariaLabel
  } = t0;
  const fullWidth = t1 === undefined ? false : t1;
  const [internalOpen, setInternalOpen] = useState(false);
  let T0;
  let T1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== ariaLabel || $[1] !== caretIcon || $[2] !== className || $[3] !== disabled || $[4] !== fullWidth || $[5] !== internalOpen || $[6] !== onChange || $[7] !== onClose || $[8] !== onOpen || $[9] !== open || $[10] !== options || $[11] !== renderValue || $[12] !== required || $[13] !== setOpen || $[14] !== value) {
    let t16;
    if ($[31] !== value) {
      t16 = opt => opt.value === value;
      $[31] = value;
      $[32] = t16;
    } else {
      t16 = $[32];
    }
    const selectedOption = options.find(t16);
    T1 = Select;
    t11 = open ?? internalOpen;
    if ($[33] !== value) {
      t12 = value ? JSON.stringify(value) : "";
      $[33] = value;
      $[34] = t12;
    } else {
      t12 = $[34];
    }
    if ($[35] !== onChange) {
      t13 = value_0 => {
        onChange(JSON.parse(value_0) as TValue);
      };
      $[35] = onChange;
      $[36] = t13;
    } else {
      t13 = $[36];
    }
    if ($[37] !== onClose || $[38] !== onOpen) {
      t14 = open_0 => {
        if (open_0) {
          onOpen?.();
        } else {
          onClose?.();
        }
      };
      $[37] = onClose;
      $[38] = onOpen;
      $[39] = t14;
    } else {
      t14 = $[39];
    }
    t15 = required;
    T0 = SelectTrigger;
    t2 = "ml-0";
    const t17 = !fullWidth;
    const t18 = selectedOption?.color === "n-violet-platform";
    const t19 = selectedOption?.color === "n-blue";
    const t20 = selectedOption?.color === "n-red";
    if ($[40] !== className || $[41] !== t17 || $[42] !== t18 || $[43] !== t19 || $[44] !== t20) {
      t3 = cn("flex h-6 items-center gap-1 rounded-md border-none px-2 text-white focus:ring-0", {
        "max-w-max": t17,
        "bg-n-violet-platform/30": t18,
        "bg-n-blue/30": t19,
        "bg-n-red/30": t20
      }, className);
      $[40] = className;
      $[41] = t17;
      $[42] = t18;
      $[43] = t19;
      $[44] = t20;
      $[45] = t3;
    } else {
      t3 = $[45];
    }
    if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = {};
      $[46] = t4;
    } else {
      t4 = $[46];
    }
    t5 = disabled;
    if ($[47] !== internalOpen || $[48] !== open || $[49] !== setOpen) {
      t6 = () => {
        if (setOpen) {
          setOpen(!open);
        } else {
          setInternalOpen(!internalOpen);
        }
      };
      $[47] = internalOpen;
      $[48] = open;
      $[49] = setOpen;
      $[50] = t6;
    } else {
      t6 = $[50];
    }
    t7 = caretIcon;
    t8 = ariaLabel;
    const t21 = selectedOption?.color === "n-violet-platform";
    const t22 = selectedOption?.color === "n-blue";
    const t23 = selectedOption?.color === "n-red";
    let t24;
    if ($[51] !== t21 || $[52] !== t22 || $[53] !== t23) {
      t24 = cn("size-2 rounded-full", {
        "bg-n-violet-platform": t21,
        "bg-n-blue": t22,
        "bg-n-red": t23
      });
      $[51] = t21;
      $[52] = t22;
      $[53] = t23;
      $[54] = t24;
    } else {
      t24 = $[54];
    }
    if ($[55] !== t24) {
      t9 = <div className={t24} />;
      $[55] = t24;
      $[56] = t9;
    } else {
      t9 = $[56];
    }
    t10 = renderValue ? renderValue?.(value, {
      icon: selectedOption?.icon
    }) : <span className="text-sm">{selectedOption?.label}</span>;
    $[0] = ariaLabel;
    $[1] = caretIcon;
    $[2] = className;
    $[3] = disabled;
    $[4] = fullWidth;
    $[5] = internalOpen;
    $[6] = onChange;
    $[7] = onClose;
    $[8] = onOpen;
    $[9] = open;
    $[10] = options;
    $[11] = renderValue;
    $[12] = required;
    $[13] = setOpen;
    $[14] = value;
    $[15] = T0;
    $[16] = T1;
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
    $[20] = t13;
    $[21] = t14;
    $[22] = t15;
    $[23] = t2;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
  } else {
    T0 = $[15];
    T1 = $[16];
    t10 = $[17];
    t11 = $[18];
    t12 = $[19];
    t13 = $[20];
    t14 = $[21];
    t15 = $[22];
    t2 = $[23];
    t3 = $[24];
    t4 = $[25];
    t5 = $[26];
    t6 = $[27];
    t7 = $[28];
    t8 = $[29];
    t9 = $[30];
  }
  let t16;
  if ($[57] !== T0 || $[58] !== t10 || $[59] !== t2 || $[60] !== t3 || $[61] !== t4 || $[62] !== t5 || $[63] !== t6 || $[64] !== t7 || $[65] !== t8 || $[66] !== t9) {
    t16 = <T0 chevronClassName={t2} className={t3} style={t4} disabled={t5} onClick={t6} caretIcon={t7} aria-label={t8}>{t9}{t10}</T0>;
    $[57] = T0;
    $[58] = t10;
    $[59] = t2;
    $[60] = t3;
    $[61] = t4;
    $[62] = t5;
    $[63] = t6;
    $[64] = t7;
    $[65] = t8;
    $[66] = t9;
    $[67] = t16;
  } else {
    t16 = $[67];
  }
  let t17;
  if ($[68] !== setOpen) {
    t17 = () => {
      if (setOpen) {
        setOpen(false);
      } else {
        setInternalOpen(false);
      }
    };
    $[68] = setOpen;
    $[69] = t17;
  } else {
    t17 = $[69];
  }
  let t18;
  if ($[70] !== classNameContent || $[71] !== disableScrolling || $[72] !== onChange || $[73] !== options || $[74] !== renderContent || $[75] !== setOpen) {
    t18 = renderContent ? renderContent(options, <DefaultContent setInternalOpen={setInternalOpen} options={options} onChange={onChange} setOpen={setOpen} disableScrolling={disableScrolling} classNameContent={classNameContent} />) : <DefaultContent setInternalOpen={setInternalOpen} options={options} onChange={onChange} setOpen={setOpen} disableScrolling={disableScrolling} classNameContent={classNameContent} />;
    $[70] = classNameContent;
    $[71] = disableScrolling;
    $[72] = onChange;
    $[73] = options;
    $[74] = renderContent;
    $[75] = setOpen;
    $[76] = t18;
  } else {
    t18 = $[76];
  }
  let t19;
  if ($[77] !== t18) {
    t19 = <div>{t18}</div>;
    $[77] = t18;
    $[78] = t19;
  } else {
    t19 = $[78];
  }
  let t20;
  if ($[79] !== t17 || $[80] !== t19) {
    t20 = <SelectContent onPointerDownOutside={t17} disableScrolling={true}>{t19}</SelectContent>;
    $[79] = t17;
    $[80] = t19;
    $[81] = t20;
  } else {
    t20 = $[81];
  }
  let t21;
  if ($[82] !== T1 || $[83] !== t11 || $[84] !== t12 || $[85] !== t13 || $[86] !== t14 || $[87] !== t15 || $[88] !== t16 || $[89] !== t20) {
    t21 = <T1 open={t11} value={t12} onValueChange={t13} onOpenChange={t14} required={t15}>{t16}{t20}</T1>;
    $[82] = T1;
    $[83] = t11;
    $[84] = t12;
    $[85] = t13;
    $[86] = t14;
    $[87] = t15;
    $[88] = t16;
    $[89] = t20;
    $[90] = t21;
  } else {
    t21 = $[90];
  }
  return t21;
}
export function UISelect(t0) {
  const $ = _c(49);
  const {
    className,
    disabled,
    value,
    options,
    onChange,
    placeholder,
    selectedItemIcon,
    onOpen,
    onClose,
    open,
    setOpen,
    disableScrolling,
    classNameContent,
    renderValue,
    caretIcon,
    required,
    fullWidth: t1,
    renderContent,
    ariaLabel
  } = t0;
  const fullWidth = t1 === undefined ? false : t1;
  const [internalOpen, setInternalOpen] = useState(false);
  const t2 = open ?? internalOpen;
  let t3;
  if ($[0] !== value) {
    t3 = value ? JSON.stringify(value) : "";
    $[0] = value;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== onChange) {
    t4 = value_0 => {
      onChange(JSON.parse(value_0) as TValue);
    };
    $[2] = onChange;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== onClose || $[5] !== onOpen) {
    t5 = open_0 => {
      if (open_0) {
        onOpen?.();
      } else {
        onClose?.();
      }
    };
    $[4] = onClose;
    $[5] = onOpen;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = !fullWidth;
  let t7;
  if ($[7] !== className || $[8] !== t6) {
    t7 = cn("flex items-center gap-1.5 focus:ring-0", {
      "max-w-max": t6
    }, className);
    $[7] = className;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== internalOpen || $[11] !== open || $[12] !== setOpen) {
    t8 = () => {
      if (setOpen) {
        setOpen(!open);
      } else {
        setInternalOpen(!internalOpen);
      }
    };
    $[10] = internalOpen;
    $[11] = open;
    $[12] = setOpen;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = value ? selectedItemIcon : null;
  let t10;
  if ($[14] !== options || $[15] !== placeholder || $[16] !== renderValue || $[17] !== value) {
    t10 = renderValue ? renderValue?.(value, {
      icon: options?.find(opt => opt.value === value)?.icon
    }) : <SelectValue placeholder={placeholder ?? "Select a value"} />;
    $[14] = options;
    $[15] = placeholder;
    $[16] = renderValue;
    $[17] = value;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== ariaLabel || $[20] !== caretIcon || $[21] !== disabled || $[22] !== t10 || $[23] !== t7 || $[24] !== t8 || $[25] !== t9) {
    t11 = <SelectTrigger className={t7} disabled={disabled} onClick={t8} caretIcon={caretIcon} aria-label={ariaLabel}>{t9}{t10}</SelectTrigger>;
    $[19] = ariaLabel;
    $[20] = caretIcon;
    $[21] = disabled;
    $[22] = t10;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== setOpen) {
    t12 = () => {
      if (setOpen) {
        setOpen(false);
      } else {
        setInternalOpen(false);
      }
    };
    $[27] = setOpen;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== classNameContent || $[30] !== disableScrolling || $[31] !== onChange || $[32] !== options || $[33] !== renderContent || $[34] !== setOpen) {
    t13 = renderContent ? renderContent(options, <DefaultContent setInternalOpen={setInternalOpen} options={options} onChange={onChange} setOpen={setOpen} disableScrolling={disableScrolling} classNameContent={classNameContent} />) : <DefaultContent setInternalOpen={setInternalOpen} options={options} onChange={onChange} setOpen={setOpen} disableScrolling={disableScrolling} classNameContent={classNameContent} />;
    $[29] = classNameContent;
    $[30] = disableScrolling;
    $[31] = onChange;
    $[32] = options;
    $[33] = renderContent;
    $[34] = setOpen;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== t13) {
    t14 = <div>{t13}</div>;
    $[36] = t13;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== t12 || $[39] !== t14) {
    t15 = <SelectContent onPointerDownOutside={t12} disableScrolling={true}>{t14}</SelectContent>;
    $[38] = t12;
    $[39] = t14;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== required || $[42] !== t11 || $[43] !== t15 || $[44] !== t2 || $[45] !== t3 || $[46] !== t4 || $[47] !== t5) {
    t16 = <Select open={t2} value={t3} onValueChange={t4} onOpenChange={t5} required={required}>{t11}{t15}</Select>;
    $[41] = required;
    $[42] = t11;
    $[43] = t15;
    $[44] = t2;
    $[45] = t3;
    $[46] = t4;
    $[47] = t5;
    $[48] = t16;
  } else {
    t16 = $[48];
  }
  return t16;
}
type DefaultContentProps<TValue> = Pick<Props<TValue>, 'options' | 'onChange' | 'setOpen' | 'disableScrolling' | 'classNameContent'> & {
  setInternalOpen: (open: boolean) => void;
};
function DefaultContent(t0) {
  const $ = _c(12);
  const {
    options,
    onChange,
    setOpen,
    disableScrolling,
    classNameContent,
    setInternalOpen
  } = t0;
  const t1 = disableScrolling ? classNameContent : classNameContent + " overflow-y-scroll";
  let t2;
  if ($[0] !== onChange || $[1] !== options || $[2] !== setInternalOpen || $[3] !== setOpen) {
    let t3;
    if ($[5] !== onChange || $[6] !== setInternalOpen || $[7] !== setOpen) {
      t3 = option => <li key={JSON.stringify(option.value)}><SelectItem value={JSON.stringify(option.value)} onClick={ev => {
          ev.preventDefault();
          onChange(option.value);
          if (setOpen) {
            setOpen(false);
          } else {
            setInternalOpen(false);
          }
        }}><div className="flex items-center gap-2"><span>{option.icon}</span><span>{option.label}</span></div></SelectItem></li>;
      $[5] = onChange;
      $[6] = setInternalOpen;
      $[7] = setOpen;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = options.map(t3);
    $[0] = onChange;
    $[1] = options;
    $[2] = setInternalOpen;
    $[3] = setOpen;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <ul className={t1}>{t2}</ul>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}